<template>
  <div class="tab-common-pick">
    <div class="tab-common-pick__title">
      System Bet 7, 8, 9, 10, 11, 12 for numbers
    </div>
    <div class="tab-common-pick__content">
      <div class="tab-common-pick__content-label">
        Select the number of combinations
      </div>
      <b-dropdown
        :text="textDropdown"
        variant="outline-danger"
        class="tab-common-pick__content-dropdown"
      >
        <b-dropdown-item
          v-for="(item, index) in listNumbers"
          :key="index"
          @click="changeItem(item.number)"
        >
          {{ item.number }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
  // import { lotoNumbers } from '@/resources/loto'
  import lottoService from '@/services/lotto.service';
export default {
  data() {
    return {
      lotoNumbers: [],
      textDropdown: '7',
      listNumbers: [
        { number: '7', active: true },
        { number: '8', active: false },
        { number: '9', active: false },
        { number: '10', active: false },
        { number: '11', active: false },
        { number: '12', active: false }
      ]
    }
  },
  created() {
    this.$store.dispatch('updateTicketType', 'combination');
    this.$store.dispatch('addOrUpdateTickets', []);
    this.changeItem(this.textDropdown);
  },
  methods: {
    changeItem(number) {
      this.textDropdown = number;
      const numbers = Array(28).fill().map((_, index) => index + 1);
      const extraNumbersLength = (parseFloat(number) - 7) + 1;

      numbers.sort(() => Math.random() - 0.5);
      const numbersRandom = numbers.slice(0, 7+extraNumbersLength);

      this.lotoNumbers = lottoService.generateTickets(1);
      this.lotoNumbers[0].forEach((item) => {
        item.active = numbersRandom.includes(item.number) ? true : false;
      });

      this.$store.dispatch('addOrUpdateTickets', this.lotoNumbers);
      this.$store.dispatch('updateTotalAmount', number);
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/common/loto/tab-common.scss"/>
